// extracted by mini-css-extract-plugin
export default {"wrapper":"diff-words_wrapper__OlocQ"};